import * as MSAL from '@azure/msal-browser'
import config from '../config.js'

const msalClient = () => {
  return new MSAL.PublicClientApplication(config.msal)
}

export default msalClient
